<template>
  <multipane class="custom-resizer" layout="vertical">

    <template v-if="layout === 'split' || layout === 'left'">
      <div class="pane" style="width: 100vw">
        <router-view :routeName="routeName"></router-view>
      </div>
    </template>

    <multipane-resizer></multipane-resizer>

    <template v-if="layout === 'split' || layout === 'right'">
      <div class="pane" style="width: 100vw">
        <template v-if="params.id">
          <router-view :routeName="routeName" name="a"></router-view>
        </template>
        <template v-else>
          <div class="index-box"></div>
        </template>
      </div>
    </template>

  </multipane>
</template>

<script>
export default {
  data () {
    return {
      routeName: {
        name: 'tutorindex2'
      }
    }
  },

  computed: {
    params () {
      return this.$route.params
    },

    layout () {
      return this.$store.getters.layout
    }
  },

  methods: {
    // getTutors: function () {
    //   this.$store.dispatch('getTutors')
    // },

    getOffices () {
      this.$store.dispatch('getOffices')
    },

    getPrefs () {
      this.$store.dispatch('getPrefs')
    },

    getUsers () {
      this.$store.dispatch('getUsers')
    },

    getUser () {
      this.$store.dispatch('getUser')
    },

    getChannels () {
      this.$store.dispatch('getChannels')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // vm.getTutors()
      vm.getOffices()
      vm.getPrefs()
      vm.getUsers()
      vm.getUser()
      vm.getChannels()
    })
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.multipane > div {
  z-index: auto;
}
.custom-resizer {
  width: 100%;
  height: calc(100vh - 100px);
}
.custom-resizer > .pane {
  text-align: left;
  /* padding: 15px; */
  overflow: hidden;
  /* background: #eee; */
  /* border: 1px solid #ccc; */
}
.custom-resizer > .multipane-resizer {
  margin: 0;
  left: 0;
  position: relative;
  &:before {
    display: block;
    content: "";
    /* width: 3px; */
    width: 2px;
    height: 40px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    /* margin-left: -1.5px; */
    margin-left: -2px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
  }
  &:hover {
    &:before {
      border-color: #999;
    }
  }
}
.index-box {
  height: calc(100vh - 112px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f19d";
    font-family: FontAwesome;
    position: absolute;
    font-size: 300px;
    top: 50%;
    left: 50%;
    margin-top: -150px;
    margin-left: -150px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>



// WEBPACK FOOTER //
// Tutors2.vue?7aab595b